<template>
	<div class="app-container">
		<el-row class="navigation">
			<el-col align="left">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '' }">当前位置:</el-breadcrumb-item>
					<el-breadcrumb-item :to="{ path: '/main/index' }">首页</el-breadcrumb-item>
					<el-breadcrumb-item :to="{ path: '/main/zscqzhfw/flfgzc' }">政策指南</el-breadcrumb-item>
					<el-breadcrumb-item>详情</el-breadcrumb-item>
				</el-breadcrumb>
			</el-col>
		</el-row>

		<el-row class="content">
			<h1 style="font-family: 微软雅黑, 宋体">{{detail.lawName}}</h1>
			<el-row class="soure">
				<span style="padding-right: 45px;">发布时间：{{ parseTime(detail.lawPubtime, '{y}-{m}-{d}') }}</span><span
					style="padding-right: 45px;">访问量：{{browseCount}}</span><span>来源：{{detail.lawPuborg}}</span><span
					style="cursor: pointer;padding-left: 45px;color: #00afff" @click="historyInfo(detail.recid)"
					v-if="detail.isCollect=='N' && islogin">收藏</span><span
					style="cursor: pointer;padding-left: 45px;color: #00afff" @click="historyInfo(detail.recid)"
					v-if="detail.isCollect=='Y' && islogin">取消收藏</span>
			</el-row>
			<div v-html="detail.lawContent" class="eidt-content"></div>
			<el-row class="row" v-if="detail.sysAttachments != '' && detail.sysAttachments != null">
				<el-col>
					<div align="left">附件：</div>
					<div v-for="(item, index) in detail.sysAttachments" :key="index" @click="handleDownload(item)"
						class="down">
						{{item.fileName}}
					</div>
				</el-col>
			</el-row>
		</el-row>

	</div>
</template>

<script>
	import {
		getBrowseCount
	} from "@/api/basedata/records";
	import {
		lawDetail,
		lawDetailNew
	} from "@/api/law/jbxx/law";
	import {
		updateCollect
	} from "@/api/collect/collect";
  import {updatePvNum} from "@/api/itempv/pv";
	export default {
		name: "detail",
		data() {
			return {
				islogin: false,
				ywFwjgRecid: undefined,
				// 遮罩层
				loading: true,
				recid: undefined,
				type: undefined,
				detail: {},
				browseCount: undefined,
				ywViews: {
					busRecid: undefined,
					busTableName: 'sys_law',
				},
			}
		},
		created() {
			let ssessionLogin = JSON.parse(localStorage.getItem('ssessionLoginUser'));
			if (ssessionLogin != null) {
				this.islogin = ssessionLogin.islogin;
				this.ywFwjgRecid = ssessionLogin.user.ywFwjgRecid;
			}
			this.recid = this.$route.params && this.$route.params.recid;
			this.getDetail();
		},
		methods: {
			historyInfo(recid) {
				/**加入收藏**/
				let uform = {};
				uform.ywFwjgRecid = this.ywFwjgRecid;
				uform.busRecid = this.detail.recid;
				uform.title = this.detail.lawName;
				uform.tableName = "sys_law";
				uform.url = "main/zscqzhfw/flfgzc/detail";
				updateCollect(uform).then(response => {
					if (response.code === 200) {
						this.msgSuccess(response.msg);
						this.refresh();
					} else {
						this.msgError(response.msg);
					}
				});
			},
			toPage(url) {
				this.$router.push({
					path: url,
				});
				this.$store.commit('SET_MAININDEX', url);
			},
			refresh() {
				this.getDetail();
			},
			getDetail() {
				let recid = this.recid;
				let qform = {};
				qform.recid = this.recid;
				qform.ywFwjgRecid = this.ywFwjgRecid;
				lawDetailNew(qform).then(response => {
					// console.log(response)
					this.detail = response.data;
					this.getBrowseData();
				});
        updatePvNum("zlts_ylqxcx_flfg").then(response => {
          //pv 点击法律法规详情
        });
				/*this.detail={
				    title:'中国质量奖管理办法',
				    updateTime:'2021-10-13 10:17',
				    deptname:'国家市场监督管理局',
				    content:'<p style="text-align: left;">各区市、国家级开发区市场监管局，南海新区综合监管执法局，各有关单位和个人：</p><p style="text-align: left; text-indent: 2em;">“威知讲堂”第十五课将于近期开讲，本次培训的主题为“专利奖项目选择与申报”。现将有关事项通知如下：</p><p style="text-align: left; text-indent: 2em;">一、培训时间</p><p style="text-align: left; text-indent: 2em;">10月18日（星期一）下午2:00-4:30。</p><p style="text-align: left; text-indent: 2em;">二、培训地点</p><p style="text-align: left; text-indent: 2em;">威海市市场监督管理局7楼712-713在线教育远程教室（威海市海滨南路49号）。</p><p style="text-align: left; text-indent: 2em;">三、培训人员</p><p style="text-align: left; text-indent: 2em;">各区市知识产权主管部门、知识产权代理机构和企业知识产权工作人员、个人等。</p><p style="text-align: left; text-indent: 2em;">四、培训形式</p><p style="text-align: left; text-indent: 2em;">培训采用远程视频方式授课。环翠区、经区与会人员可以到市市场监管局参加培训，其他区市自行组织辖区内企业就地参加培训，或通知辖区内的企业、个人自行参加培训。原则上各区市知识产权主管部门工作人员都要参加。</p><p style="text-align: left; text-indent: 2em;">腾讯视频会议ID：817 979 410，密码：123456。</p><p style="text-align: left; text-indent: 2em;">五、其他事项</p><p style="text-align: left; text-indent: 2em;">自行组织培训的区市请准备好“腾讯会议”软件，听课所需的投影仪、音箱等设备，10月18日下午提前15分钟登录软件调试；培训结束后3个工作日内将会议照片、签到表（PDF版）发到中心邮箱。</p><p style="text-align: left; text-indent: 2em;">六、授课老师简介</p><p style="text-align: left; text-indent: 2em;">授课老师郝瑞刚，资深专利代理师，北京市知识产权专家库专家，北京市知识产权服务领军人才，中国民营科技实业家协会副理事长，知识产权管理体系审核员，知识产权纠纷人民调解委员会人民调解员，现任北京开阳星知识产权代理有限公司总经理。</p><p style="text-align: left; text-indent: 2em;">郝老师从事知识产权工作十余年，具有丰富的知识产权管理经验。曾为企业开展专利申请、专利挖掘、专利布局、无形资产评估、知识产权贯标辅导等培训上百次；担任多家企事业单位的多项侵权预警分析、知识产权海外预警分析、行业专利分析和企业知识产权战略课题等项目，曾荣获“十佳知识产权咨询师”；完成二十项行业专利分析报告，包括5G技术、无人机、自动驾驶、共享单车、光科技、3D打印等领域；辅导过数家企业获得“中国专利奖”；参与中国铁建关于“高速铁路40m预应力混凝土简支箱梁运架技术”的重大专项海内外预警分析项目；参与中国机器人产业发展报告的编撰，出版《机器人产业发展蓝皮书2020-2021》；受邀聘请为“2019年、2020年及2021年海淀高价值专利培育大赛”、“2020年、2021年粤港澳大湾区高价值专利培育布局大赛”、“2020年、2021年山东新旧动能转换高价值专利培育大赛”的评议专家。</p><p style="text-align: left; text-indent: 2em;">联 系 人：孔霞 &nbsp;&nbsp;联系电话：5803699</p><p style="text-align: left; text-indent: 2em;">中心邮箱：zscqsyfzzx@wh.shandong.cn</p><p><br></p><p style="text-align: left; text-indent: 2em;"><br></p><p><br></p><p style="text-align: right; text-indent: 2em;">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;威海市知识产权事业发展中心</p><p style="text-align: right; text-indent: 2em;">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;2021年10月13日<br></p><p><br></p>'
				};*/
				//this.getBrowseData();
			},
			getBrowseData() {
				this.ywViews.busRecid = this.recid;
				getBrowseCount(this.ywViews).then(response => {
					this.browseCount = response;
				})
			},

			//下载附件
			handleDownload(file) {
				var name = file.fileName;
				var url = file.path;
				const a = document.createElement('a');
				a.setAttribute('download', name);
				a.setAttribute('target', '_blank');
				a.setAttribute('href', process.env.VUE_APP_BASE_API + url);
				a.click();
			},
		}
	}
</script>

<style scoped>
	.app-container {
		padding: 0px 15px 20px;
		background-color: #ffffff;
	}

	.navigation {
		padding: 20px 15px;
		line-height: 20px;
		height: 60px;
		background-color: #F5F5F5;
		margin-bottom: 15px;
	}

	.content {
		border: 1px solid #cccccc;
		padding: 20px 80px;
	}

	.soure {
		background-color: #f3f3f3;
		padding: 10px;
		margin: 25px 0;
	}

	.eidt-content {
		text-align: left;
	}

	.down {
		cursor: pointer;
		margin-top: 1rem;
		align: left;
		text-align: left;
	}

	.down:hover {
		color: #2467d2;
	}
</style>
